import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Home from "@/components/dashboard/Home";
import Profile from "@/components/dashboard/Profile";
import MyArticles from "@/components/dashboard/MyArticles";
import StoreStatistics from "@/components/dashboard/StoreStatistics";
import Login from "@/views/Login";
import Store from "@/views/Store";
import ServicesView from "@/views/ServicesView";
import ArticleView from "@/views/ArticleView";
import { auth } from "@/firebase";

Vue.use(VueRouter);

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    components: { default: Dashboard },
    children: [
      {
        path: "/dashboard/home",
        components: { a: Home },
      },
      {
        path: "/dashboard/profile",
        components: { b: Profile },
      },
      {
        path: "/dashboard/articles",
        components: { c: MyArticles },
      },
      {
        path: "/dashboard/store-stat",
        components: { c: StoreStatistics },
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Home.vue"),
  },
  {
    name: "Login",
    path: "/login",
    component: Login,
    meta: {
      requiresGuest: true,
    },
  },
  {
    name: "Store",
    path: "/store",
    component: Store,
  },
  {
    name: "ServicesView",
    path: "/services/:id",
    component: ServicesView,
  },
  {
    name: "ArticleView",
    path: "/article/:id",
    component: ArticleView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    auth.onAuthStateChanged((user) => {
      if (!user) {
        console.log(user);
        next({ path: "/login" });
      } else {
        next();
      }
    });
  } else if (to.matched.some((record) => record.meta.requiresGuest)) {
    auth.onAuthStateChanged((user) => {
      if (user) {
        next({
          path: "/",
          query: {
            redirect: to.fullPath,
          },
        });
      } else {
        next();
      }
    });
  } else {
    next();
  }
});

export default router;
